import { LoaderActions } from '@store/loaders'
import { managerActions } from '@store/reducers/manager/actions'
import type { Location } from 'react-router-dom'
import type { Action } from 'redux'
import { LOCATION_CHANGE } from 'redux-first-history'
import { put, race, take } from 'redux-saga/effects'

import { InboxActions } from '../actions'
import { itemLoader, itemPath } from '../utils'

interface LocationChange {
  payload: { location: Location }
}

interface OpeningOutcome {
  moved?: LocationChange
}

// The project is loaded before the route changes, as a dashboard card does:
// a bare push would leave the previous project in the store, and the socket
// reconnecting on the artboard would fetch that one over the new.
// The row is read only once we are there: read at the click, it would jump
// out of "New to you" while the project is still loading
export function* open({
  payload: { item },
}: ReturnType<typeof InboxActions.open>) {
  const path = itemPath(item)
  const loader = itemLoader(item)

  yield put(
    managerActions.openProjectSaga({ id: item.project.id, path, loader })
  )

  if (item.readAt !== null) {
    return
  }

  // the route changes before the loader goes off; a failed or cancelled
  // opening only takes the loader off
  const { moved }: OpeningOutcome = yield race({
    moved: take(LOCATION_CHANGE),
    done: take(
      (action: Action) =>
        LoaderActions.unset.match(action) && action.payload === loader
    ),
  })

  const arrived =
    moved !== undefined &&
    `${moved.payload.location.pathname}${moved.payload.location.search}` ===
      path

  if (arrived) {
    yield put(
      InboxActions.markRead({ workspace: item.workspace, ids: [item.id] })
    )
  }
}
